<template>
  <div class="page">
    <!-- 搜索 -->
    <div class="pageTitleBox">
      <div class="boxNameL">会员基本信息</div>
      <div class="boxNameR">
        <el-button type="warning" @click="$router.back()" size="small">返回</el-button>
      </div>
    </div>
    <div class="msg" style="">
      <div class="msgItem" style="width: 100%">
        <div style="
            line-height: 16px;
            margin: 12px 0;
            border-left: 2px solid #f5882a;
            padding-left: 3px;
            font-size: 14px;
          ">
          会员资料
        </div>
        <img style="width: 14px; height: 14px; margin: 12px 5px; cursor: pointer" src="../../../assets/img/edit.png"
          @click="open_dialogUser" />
      </div>
      <div class="msgItem">
        <div class="msgLabel">姓名：</div>
        <div class="msgValue">
          {{ userDetail.basic_info.nick_name }}
          <span v-if="userDetail.lifeLong && userDetail.lifeLong.status === 1">
            <el-tooltip effect="dark" :content="userDetail.lifeLong.remark" placement="top-start">
              <img style="height: 16px; cursor: pointer" src="../../../assets/img/zhong.png" />
            </el-tooltip>
          </span>
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">会员剩余天数：</div>
        <div class="msgValue">{{ userDetail.club_card.surplus_day }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">性别：</div>
        <div class="msgValue">{{ userDetail.basic_info.sex }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">电话：</div>
        <div class="msgValue">{{ userDetail.basic_info.user_mobile }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">邮箱：</div>
        <div class="msgValue">{{ userDetail.basic_info.user_email }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">家庭住址：</div>
        <div class="msgValue">
          <el-popover placement="top-start" width="200" trigger="hover" :content="userDetail.basic_info.home_address">
            <div slot="reference" style="
                width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
              ">
              {{ userDetail.basic_info.home_address }}
            </div>
          </el-popover>
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">生日：</div>
        <div class="msgValue" v-if="userDetail.basic_info.birthday">
          {{ this.$public.FTime(userDetail.basic_info.birthday, "YYYY-MM-DD") }}
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">成长值：</div>
        <div class="msgValue">{{ userDetail.card_info.growth_value }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">会员备注：</div>
        <div class="msgValue">{{ userDetail.basic_info.remark }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">会员年龄段：</div>
        <div class="msgValue">{{
          userDetail.basic_info.age_group.length ? userDetail.basic_info.age_group[0] + '--' +
            userDetail.basic_info.age_group[1] : '--'
        }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">会员来源:</div>
        <div class="msgValue">{{ userDetail.basic_info.user_source ? userDetail.basic_info.user_source : '--' }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">注册地：</div>
        <div class="msgValue">{{ userDetail.company_info.shop_name }}</div>
      </div>
    </div>
    <div class="msg">
      <div class="msgItem">
        <div class="msgLabel">卡号：</div>
        <div class="msgValue">{{ userDetail.card_info.card_id }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">卡类型：</div>
        <div class="msgValue">会员卡</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">余额：</div>
        <div class="msgValue">
          {{ userDetail.card_info.user_yue
          }}{{ userDetail.card_info.frozen === true ? "(锁)" : "" }}
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">赠额：</div>
        <div class="msgValue">{{ userDetail.card_info.user_zeng }}</div>
      </div>
    
      <div class="msgItem">
        <div class="msgLabel">创建时间：</div>
        <div class="msgValue">
          {{
          userDetail.operation_info &&
          $public.FTime(userDetail.operation_info.create.create_time)
        }}
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">紧急联系人：</div>
        <div class="msgValue">{{ userDetail.basic_info.urgent_user }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">紧急电话：</div>
        <div class="msgValue">
          {{ userDetail.basic_info.urgent_user_mobile }}
        </div>
      </div>
    </div>
    <div class="tabLine">
      <div class="tabItem" :class="[curTabIndex == 2 ? 'active' : '']" @click="changeTab(2)">
        宠物资料
      </div>
      <div class="tabItem" :class="[curTabIndex == 6 ? 'active' : '']" @click="changeTab(6)">
        消费卡记录
      </div>
      <div class="tabItem" :class="[curTabIndex == 1 ? 'active' : '']" @click="changeTab(1)">
        优惠券信息
      </div>
      <div class="tabItem" :class="[curTabIndex == 8 ? 'active' : '']" @click="changeTab(8)">
        礼品卡
      </div>
      <!-- <div class="tabItem" :class="[curTabIndex==5?'active':'']" @click="changeTab(5)">押金信息</div> -->
      <div class="tabItem" :class="[curTabIndex == 3 ? 'active' : '']" @click="changeTab(3)">
        消费记录
      </div>
      <div class="tabItem" :class="[curTabIndex == 4 ? 'active' : '']" @click="changeTab(4)">
        充值记录
      </div>
      <div class="tabItem" :class="[curTabIndex == 7 ? 'active' : '']" @click="changeTab(7)">
        退换货记录
      </div>
      <div class="tabItem" :class="[curTabIndex == 9 ? 'active' : '']" @click="changeTab(9)">
        会员记录
      </div>
    </div>
    <div class="tableBox">
      <!-- 消费卡信息 -->
      <div class="table2" v-show="curTabIndex == 6">
        <tab6 :userId="userDetail._id"></tab6>
      </div>
      <!-- 优惠券信息 -->
      <div class="table2" v-show="curTabIndex == 1">
        <div v-if="$buttonAuthority('huiyuan-giveCoupon')" class="searchLine">
          <div class="search" style="padding-bottom: 10px">
            <div class="searchL"></div>
            <div class="searchR" style="padding: 16px 16px 0 0">
              <el-button v-if="$buttonAuthority('huiyuan-giveCoupon')" @click="open_drawerGiveCoupon"
                size="small">赠送优惠券</el-button>
            </div>
          </div>
        </div>

        <el-table class="table" :data="discountList" style="width: 100%; padding: 0">
          <el-table-column label="优惠券名称" column-key="table4_1">
            <template slot-scope="scope">
              {{ scope.row.coupon_name }}
            </template>
          </el-table-column>
          <el-table-column label="订单号" column-key="table4_1">
            <template slot-scope="scope">
              <a style="color: #35c; text-decoration: underline; cursor: pointer" :href="$public.base +
          '/dingdan/saleOrderSee?id=' +
          scope.row.order_no
          ">{{ scope.row.order_no }}</a>
            </template>
          </el-table-column>
          <el-table-column label="面额" column-key="table4_1">
            <template slot-scope="scope">
              {{ scope.row.money_reduce }}
            </template>
          </el-table-column>
          <el-table-column label="满减规格" column-key="table4_2">
            <template slot-scope="scope">
              <span v-if="scope.row.activity_type == 1">满 {{ scope.row.money_top }}元 减{{
          scope.row.money_reduce
        }}元</span>
              <span v-if="scope.row.activity_type == 2">满 {{ scope.row.rebate_top }} 元打{{
          scope.row.rebate * 10
        }}折</span>
              <span v-if="scope.row.activity_type == 3">抵扣</span>
            </template>
          </el-table-column>
          <el-table-column label="优惠券编码" column-key="table4_2">
            <template slot-scope="scope">
              {{ scope.row._no }}
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <el-table-column label="领取时间" width="100" column-key="table4_1">
            <template slot-scope="scope">
              <span>{{
          $public.FTime(scope.row.receive_time, "YYYY-MM-DD")
        }}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.use_start_time, "YYYY-MM-DD") }} --
              {{ $public.FTime(scope.row.use_end_time, "YYYY-MM-DD") }}
            </template>
          </el-table-column>
          <el-table-column label="使用门店" width="150" column-key="table4_1">
            <template slot-scope="scope">
              <span>{{ scope.row.use_shop }}</span>
            </template>
          </el-table-column>
          <el-table-column label="使用时间" width="100" column-key="table4_1">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.use_time, "YYYY-MM-DD") }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.use_status == 0" style="color: #999">不可用</span>
              <span v-if="scope.row.use_status == 1" style="color: #f00">未使用</span>
              <span v-if="scope.row.use_status == 2" style="color: #000">已使用</span>
              <span v-if="scope.row.use_status == 3" style="color: #999">已过期</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="110">
            <template slot-scope="scope">
              {{ scope.row.remark }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope">
              <el-button type="text" @click="see(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <page :page="page_discount.page" :total="page_discount.total" @change="page_discountChange"></page>
      </div>
      <!-- 礼品卡 -->
      <div class="table2" v-show="curTabIndex == 8">
        <!-- <div class="searchLine">
					<div class="search" style="padding-bottom:10px;">
						<div class="searchL">
						</div>
						<div class="searchR" style="padding:16px 16px 0 0;">
						</div>
					</div>
				</div> -->
        <el-table class="table" :data="giftCardList" style="width: 100%; padding: 0">
          <el-table-column label="礼品卡名称">
            <template slot-scope="scope">
              <div>{{ scope.row.card_name }}</div>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              {{ scope.row.card_type && scope.row.card_type.title }}
            </template>
          </el-table-column>
          <el-table-column label="卡号" width="180">
            <template slot-scope="scope">
              {{ scope.row.card_number }}
            </template>
          </el-table-column>
          <el-table-column label="面额" width="200">
            <template slot-scope="scope">
              {{ scope.row.price }}
            </template>
          </el-table-column>
          <el-table-column label="剩余金额" width="200">
            <template slot-scope="scope">
              {{ scope.row.surplus_money }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="curGiftCard = scope.row;
        giftCardSee_state = true;
        ">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <page :page="page_giftCard.page" :total="page_giftCard.total" @change="page_giftCardChange"></page>
      </div>
      <!-- 宠物 -->
      <div class="table3" v-show="curTabIndex == 2">
        <div class="searchLine">
          <div class="search" style="padding-bottom: 10px">
            <div class="searchL"></div>
            <div class="searchR" style="padding: 16px 16px 0 0">
              <el-button @click=" openDialogAddEditPet('addPet')" size="small">添加宠物</el-button>
            </div>
          </div>
        </div>
        <el-table class="table" :data="userDetail.pets_info" style="width: 100%; padding: 0 0">
          <el-table-column label="宠物昵称" column-key="table3_1">
            <template slot-scope="scope">
              {{ scope.row.nick_name }}
              <span v-if="scope.row.lifeLong && scope.row.lifeLong.status === 1">
                <el-tooltip effect="dark" :content="scope.row.lifeLong.remark" placement="top-start">
                  <img style="height: 16px; cursor: pointer" src="../../../assets/img/zhong.png" />
                </el-tooltip>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="性别" width="60" column-key="table3_2">
            <template slot-scope="scope">
              {{ scope.row.pet_sex }}
            </template>
          </el-table-column>
          <el-table-column label="种类" width="60" column-key="table3_3">
            <template slot-scope="scope">
              {{ scope.row.apply_type.title }}
            </template>
          </el-table-column>
          <el-table-column label="品种" width="150" column-key="table3_4">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <el-table-column label="毛色" width="80" column-key="table3_5">
            <template slot-scope="scope">
              {{ scope.row.pet_color }}
            </template>
          </el-table-column>
          <el-table-column label="用具编号" width="150" column-key="table3_6">
            <template slot-scope="scope">
              {{ scope.row.tool_num }}
            </template>
          </el-table-column>
          <el-table-column label="出生日期" width="100" column-key="table3_7">
            <template slot-scope="scope">
              {{ scope.row.bron_date }}
            </template>
          </el-table-column>
          <el-table-column label="年龄" width="100" column-key="table3_8">
            <template slot-scope="scope">
              <span v-if="!$public.isNull(scope.row.bron_date)">
                {{ scope.row.petAgeArr[0] + "岁" + scope.row.petAgeArr[1] + "月" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="宠物芯片" column-key="table3_9" width="150">
            <template slot-scope="scope">
              {{ scope.row.eprom_no }}
            </template>
          </el-table-column>
          <el-table-column label="其他" width="100" column-key="table3_10">
            <template slot-scope="scope">
              {{
          scope.row.sterilization == 1 ? "已绝育" : "未绝育"
        }}&nbsp;&nbsp;&nbsp;&nbsp;
              <!-- {{scope.row.dewormed==1?'已驱虫':'未驱虫'}}&nbsp;&nbsp;&nbsp;&nbsp; -->
              {{
            scope.row.immunization == 1 ? "已免疫" : "未免疫"
          }}&nbsp;&nbsp;&nbsp;&nbsp;
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="
        $router.push({
          path: '/huiyuan/huiyuanPetSee',
          query: { uid: $route.query.id, pid: scope.row._id },
        })
          ">查看</el-button>
              <el-button type="text" size="small" @click=" openDialogAddEditPet('editPet', scope.row)">编辑</el-button>
              <el-button v-if="$buttonAuthority('huiyuan-delpet')" type="text" size="small"
                @click=" deletedPet(scope.row._id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 消费信息 -->
      <div class="table4" v-show="curTabIndex == 3" style="background-color: #fff">
        <!-- 表格4 -->
        <!-- <el-row>
					<el-col :offset="22" :span="2">
						<el-button size="mini" type="primary" style="margin-left:10px;" @click="getInvoiceForPage">一键打印本页</el-button>
					</el-col>
				</el-row> -->
        <el-table class="table" :data="orderList" style="width: 100%; padding-top: 0">
          <el-table-column label="消费地点" min-width="150" column-key="table4_1">
            <template slot-scope="scope">
              {{
          scope.row.order_source == 1
            ? "小程序"
            : scope.row.company_info && scope.row.company_info.shop_name
        }}
            </template>
          </el-table-column>
          <el-table-column label="消费单号" column-key="table4_2" min-width="140">
            <template slot-scope="scope">
              <a v-if="scope.row.order_source == 1" style="color: #35c; text-decoration: underline; cursor: pointer"
                :href="$public.base + '/dingdan/saleOrderSee?id=' + scope.row._id
          ">{{ scope.row.no }}</a>
              <a v-if="scope.row.order_source == 2" style="color: #35c; text-decoration: underline; cursor: pointer"
                :href="$public.base + '/dingdan/saleOrderSee?id=' + scope.row._id
          ">{{ scope.row.no }}</a>
            </template>
          </el-table-column>
          <el-table-column label="类型" min-width="60" column-key="table4_1">
            <template slot-scope="scope">
              <span v-if="scope.row.order_source == 1">线上</span>
              <span v-if="scope.row.order_source == 2">线下</span>
            </template>
          </el-table-column>
          <el-table-column label="结算方式" min-width="165">
            <template slot-scope="scope" v-if="scope.row.pay_info">
              <div v-for="( item, index ) in  scope.row.pay_info.pay_list " :key="index">
                <span style="padding-right: 2px">
                  {{ $public.formatPayTypeState(item.pay_type) }}
                </span>
                {{ item.money }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="order_item_list" label="原价总金额" min-width="100">
            <template slot-scope="scope">
              {{ calculateTotalPrice(scope.row.order_item_list) }}
            </template>
          </el-table-column>
          <el-table-column prop="zip" label="结算状态" min-width="100">
            <template slot-scope="scope">
              {{ $public.formatOrderState(scope.row.state) }}
            </template>
          </el-table-column>
          <el-table-column label="消费日期" min-width="160" column-key="table4_3">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_price" label="含税总金额" min-width="90" column-key="table4_4">
          </el-table-column>
          <el-table-column prop="remark" label="订单备注" min-width="100">
          </el-table-column>
          <el-table-column prop="remark" label="结算备注" min-width="100">
            <template slot-scope="scope" v-if="scope.row.pay_info">
              {{ scope.row.pay_info.pay_remark }}
            </template>
          </el-table-column>
          <el-table-column label="发票状态" width="70">
            <template slot-scope="scope">
              {{ scope.row.isHaveInvoices == true ? "已添加" : "未添加" }}
            </template>
          </el-table-column>
          <el-table-column label="回访记录" column-key="table4_6" min-width="145">
            <template slot-scope="scope">
              <a v-if="scope.row.visit_list != null &&
          scope.row.visit_list.length > 0
          " style="color: #35c; text-decoration: underline; cursor: pointer" :href="$public.base +
          '/returnVisit/returnVisitList?id=' +
          scope.row._id +
          '&from=order'
          ">查看回访记录</a>

              <span v-else>暂无回访记录</span>
              <el-button size="mini" type="text" style="margin-left: 10px"
                @click=" getInvoice(scope.row)">打印</el-button>
            </template>
          </el-table-column>
        </el-table>
        <page :page="page.page" :total="page.total" @change="pageChange"></page>
      </div>
      <!-- 充值记录 -->
      <div class="table4" v-show="curTabIndex == 4">
        <el-table class="table" :data="orderRechargeList" style="width: 100%">
          <el-table-column label="充值地点" width="200" column-key="table4_1">
            <template slot-scope="scope">
              <span v-if="scope.row.order_source == 1">小程序</span>
              <span v-if="scope.row.order_source == 2">{{
          scope.row.company_info && scope.row.company_info.shop_name
        }}</span>
              <span v-if="scope.row.order_source == 3">{{
          scope.row.company_info && scope.row.company_info.shop_name
        }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充值单号" column-key="table4_2" width="280">
            <template slot-scope="scope">
              <a v-if="scope.row.order_source == 1" style="color: #35c; text-decoration: underline; cursor: pointer"
                :href="$public.base + '/rechargeOrder/rechargeOrderSee?id=' + scope.row._id
          ">{{ scope.row.no }}</a>
              <a v-if="scope.row.order_source == 2" style="color: #35c; text-decoration: underline; cursor: pointer"
                :href="$public.base + '/rechargeOrder/rechargeOrderSee?id=' + scope.row._id
          ">{{ scope.row.no }}</a>
              <a v-if="scope.row.order_source == 3" style="color: #35c; text-decoration: underline; cursor: pointer"
                :href="$public.base + '/rechargeOrder/rechargeOrderSee?id=' + scope.row._id
          ">{{ scope.row.no }}</a>
            </template>
          </el-table-column>
          <el-table-column label="类型" width="70" column-key="table4_1">
            <template slot-scope="scope">
              <span v-if="scope.row.order_source == 1">线上</span>
              <span v-if="scope.row.order_source == 2">余额</span>
              <span v-if="scope.row.order_source == 3">押金</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="充值金额" width="100" column-key="table4_4">
          </el-table-column>
          <el-table-column label="充值方式">
            <template slot-scope="scope" v-if="scope.row.pay_info">
              <div v-for="( item, index ) in  scope.row.pay_info.pay_list " :key="index">
                <span style="padding-right: 2px">
                  {{ $public.formatPayTypeState(item.pay_type) }}
                </span>
                {{ item.money }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="结算状态" width="100">
            <template slot-scope="scope">
              {{ $public.formatOrderState(scope.row.state) }}
            </template>
          </el-table-column>
          <el-table-column label="充值日期" width="180" column-key="table4_3">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="订单备注" width="100">
          </el-table-column>
          <el-table-column label="结算备注" width="100">
            <template slot-scope="scope" v-if="scope.row.pay_info">
              {{ scope.row.pay_info.pay_remark }}
            </template>
          </el-table-column>
          <el-table-column label="发票状态" width="70">
            <template slot-scope="scope">
              {{ scope.row.isHaveInvoices == true ? "已添加" : "未添加" }}
            </template>
          </el-table-column>
        </el-table>
        <page :page="page_recharge.page" :total="page_recharge.total" @change="page_rechargeChange"></page>
      </div>
      <!-- 未知 -->
      <div class="table2" v-show="curTabIndex == 5">
        <el-table class="table" :data="depositList" style="width: 100%">
          <el-table-column prop="id" label="编号" column-key="table5_1" width="500">
          </el-table-column>
          <el-table-column prop="name" label="服务类型" column-key="table5_2">
            <template slot-scope="scope">
              {{ scope.row.typeId === 1 ? "寄养" : "" }}
              {{ scope.row.typeId === 2 ? "住院" : "" }}
            </template>
          </el-table-column>
          <el-table-column prop="deposit" label="金额" width="400" column-key="table5_3">
          </el-table-column>
          <el-table-column prop="age" label="创建时间" width="400" column-key="table5_4">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.createTime) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 退换货 -->
      <div class="table2" v-show="curTabIndex == 7">
        <el-table class="table" :data="returnOrderList" style="width: 100%">
          <el-table-column prop="no" label="退单编号" width="150">
          </el-table-column>
          <el-table-column prop="order_id" label="订单编号" width="150">
          </el-table-column>
          <el-table-column prop="name" label="顾客">
            <template slot-scope="scope">
              <div>
                {{ scope.row.user_info.nick_name }}<br />
                {{ scope.row.user_info.user_mobile }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="退换状态" width="80">
            <template slot-scope="scope">
              {{ $public.formatOrderReturnState(scope.row.state) }}
            </template>
          </el-table-column>
          <el-table-column label="结算方式" width="110">
            <template slot-scope="scope" v-if="scope.row.pay_info">
              <div v-for="( item, index ) in  scope.row.pay_info.pay_list " :key="index">
                <span style="padding-right: 2px">
                  {{ item.pay_type == -1 ? "全部" : "" }}
                  {{ item.pay_type == 0 ? "现金" : "" }}
                  {{ item.pay_type == 3 ? "线下支付宝" : "" }}
                  {{ item.pay_type == 4 ? "线下微信" : "" }}
                  {{ item.pay_type == 5 ? "pos机" : "" }}
                  {{ item.pay_type == 6 ? "找零" : "" }}
                  {{ item.pay_type == 7 ? "余额" : "" }}
                  {{ item.pay_type == 8 ? "赠额" : "" }}
                  {{ item.pay_type == 9 ? "积分" : "" }}
                  {{ item.pay_type == 11 ? "电商平台" : "" }}
                  {{ item.pay_type == 12 ? "优惠" : "" }}
                  {{ item.pay_type == 13 ? "京东聚合" : "" }}
                  {{ item.pay_type == 17 ? "拉卡拉" : "" }}
                </span>
                {{ Math.abs(item.money.toFixed(2)) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="退换方式" width="80">
            <template slot-scope="scope">
              {{
          scope.row.return_type == 1
            ? "退货"
            : scope.row.return_type == 2
              ? "换货"
              : "充值退款"
        }}
            </template>
          </el-table-column>
          <el-table-column label="订单类型" width="70">
            <template slot-scope="scope">
              {{ scope.row.source == 1 ? "线上" : "" }}
              {{ scope.row.source == 2 ? "线下" : "" }}
            </template>
          </el-table-column>
          <el-table-column label="是否入库" width="70">
            <template slot-scope="scope">
              {{ scope.row.is_into ? "是" : "" }}
              {{ !scope.row.is_into ? "否" : "" }}
            </template>
          </el-table-column>
          <el-table-column label="总金额" width="80">
            <template slot-scope="scope">
              {{ scope.row.total_price.toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="100">
          </el-table-column>
          <el-table-column label="退换日期" width="160">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="
          $router.push({
            path: '/returnOrder/returnOrderSee',
            query: { id: scope.row.no },
          })
          " type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 会员记录 -->
      <div class="table2" v-show="curTabIndex == 9">
        <div class="searchLine">
          <div class="search" style="padding-bottom: 10px">
            <div class="searchL"></div>
            <div class="searchR" style="padding: 16px 16px 0 0">
              <el-button @click="BuyCard()" size="small">购买会员卡</el-button>
            </div>
          </div>
        </div>
        <el-table class="table" :data="returnOrderList" style="width: 100%">
          <el-table-column prop="no" label="会员卡类型" width="150">
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              {{ $public.formatOrderReturnState(scope.row.state) }}
            </template>
          </el-table-column>
          <el-table-column label="开卡日期">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column label="使用日期">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column label="到期日期">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.create_time) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="dialogUser_state">
      <dialogEditUserInfo :userInfo="userDetail" @submit="submit_dialogUser"></dialogEditUserInfo>
    </div>
    <!-- 转移宠物 -->
    <div v-if="dialogTransPet_state">
      <dialogTransPet :userId="userDetail._id" :pet="curPet" @submit="submit_transPet"></dialogTransPet>
    </div>
    <!-- 添加宠物 -->
    <div v-if="dialogAddEditPet_state">
      <dialogAddEditPet :userInfo="userDetail" :petInfo="curPet" :dialog_type="operationPetType"
        @submit="dialogPet_submit"></dialogAddEditPet>
    </div>
    <!-- 购买会员卡 -->
    <div v-if="dialogBuyCard_state">
      <dialogBuyCard :userInfo="userDetail" :petInfo="curPet" :dialog_type="operationPetType"
        @submit="dialogCard_submit"></dialogBuyCard>
    </div>
    <div v-if="drawerGiveCoupon_state">
      <drawerGiveCoupon :userInfo="userDetail" @submit="submit_drawerGiveCoupon"></drawerGiveCoupon>
    </div>
    <div v-if="drawerSee_state">
      <discountSee :curItem="curItem" @submit="submit_drawerSee"></discountSee>
    </div>
    <!-- 查看礼品卡详情 -->
    <div v-if="giftCardSee_state">
      <giftCardSee :curItem="curGiftCard" @submit=" giftCardSee_state = false"></giftCardSee>
    </div>
    <!-- <iframe v-if="printUrl" :src="'ChuLinPrint:'+printUrl" width="0" height="0"></iframe> -->
  </div>
</template>
<script>
import page from "@/components/page.vue";
import tab6 from "./tab6.vue";
import dialogEditUserInfo from "../../../components/drawer/drawer_editUserInfo.vue";
// 查看优惠券
import discountSee from "@/views/mendian/shouyin/drawer/discountSee.vue";
import dialogTransPet from "../../../components/dialog_transPet.vue";
import dialogAddEditPet from "../../../components/drawer/drawer_addEditPetInfo.vue";
import dialogBuyCard from "../../../components/drawer/drawer_BuyCard.vue";
import drawerGiveCoupon from "./drawerGiveCoupon.vue";
import giftCardSee from "../../mendian/shouyin/drawer/giftCardSee.vue";
import printJs from "../../../util/print.js";
import pub from "../../../util/public.js";
export default {
  components: {
    page,
    tab6,
    dialogEditUserInfo,
    dialogTransPet,
    dialogAddEditPet,
    drawerGiveCoupon,
    giftCardSee,
    discountSee,
    dialogBuyCard
  },
  data() {
    return {
      // see查看优惠券
      drawerSee_state: false,
      curItem: null,
      curTabIndex: 2,
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      page_recharge: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      page_discount: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      page_giftCard: {
        page: 1,
        pageSize: 1000,
        total: 0,
      },
      orderList: [],
      orderRechargeList: [],
      discountList: [],
      giftCardList: [],
      depositList: [],
      returnOrderList: [],

      total: 20,
      userDetail: {
        basic_info: {},
        card_info: {},
        company_info: {},
        pets_info: [],
      },
      time: "",
      formLabelWidth: "120px",
      orderType: -1,
      tableData: [

      ],
      options: [
        {
          value: "选项1",
          label: "调拨中",
        },
        {
          value: "选项2",
          label: "调拨完成",
        },
      ],
      selectValue: "",
      dialogUser_state: false,
      // 宠物转移
      dialogTransPet_state: false,
      curPet: {},
      // 添加宠物
      dialogAddEditPet_state: false,
      // 购买会员卡
      dialogBuyCard_state: false,
      operationPetType: "",
      // 打印
      // printUrl: '',
      // 赠送优惠券
      drawerGiveCoupon_state: false,
      // 礼品卡
      giftCardSee_state: false,
      curGiftCard: {},
      curPetYear: 0,
      curPetMonth: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.path !== "/dingdan/saleOrderSee") {
      next((vm) => {
        if (vm.$route.query.tab) {
          vm.curTabIndex = vm.$route.query.tab;
        }
        vm.getUserDetail();
      });
    } else {
      next();
    }
  },
  mounted() {
    // if (this.$route.query.tab) {
    // 	this.curTabIndex = this.$route.query.tab
    // }
    // this.getUserDetail();
  },
  methods: {
    
    //计算商品总额
    calculateTotalPrice(orderItems) {
    if (!orderItems || !Array.isArray(orderItems)) return '0.00';

    const total = orderItems.reduce((sum, item) => {
      const num = Number(item.num) || 0;
      const price = Number(item.original_price) || 0;
      return sum + num * price;
    }, 0);
    
    // 格式化为两位小数（根据需求可选）
    return total.toFixed(2);
  },
    // 查看优惠券
    // 查看
    see(row) {
      this.curItem = row;
      this.drawerSee_state = true;
    },
    submit_drawerSee(obj) {
      //   console.log(obj);
      this.drawerSee_state = false;
    },
    open_dialogUser() {
      this.dialogUser_state = true;
    },
    // 赠送优惠券
    open_drawerGiveCoupon() {
      this.drawerGiveCoupon_state = true;
    },
    submit_drawerGiveCoupon(obj) {
      this.drawerGiveCoupon_state = false;
      if (obj.type === "success") {
        this.getUserDiscountList(this.userDetail._id);
      }
    },
    // 打印发票
    getInvoice(row) {
      this.$http
        .get("/api/Order/OrderReceipt", {
          orderNumber: row._id,
        })
        .then((res) => {
          if (res.code == 0) {
            let d = res.data;
            printJs.printTicketSaleOrder(d).then((r) => {
              this.$store.commit("set_printUrl", r.msg);
              // if (r.url != '') {
              // 	this.printUrl = r.url;
              // 	setTimeout(() => {
              // 		this.printUrl = '';
              // 	}, 1000)
              // }
            });
          }
        });
    },
    // getInvoiceForPage(){
    // 	for(let i=0;i<this.orderList.length;i++){
    // 		setTimeout(()=>{
    // 			this.$http.get('/api/Order/OrderReceipt', {
    // 				orderNumber: this.orderList[i]._id
    // 			}).then(res => {
    // 				if (res.code == 0) {
    // 					let d = res.data;
    // 					this.$util.print(d).then(r => {
    // 						if (r.url != '') {
    // 							this.printUrl = r.url;
    // 							setTimeout(() => {
    // 								this.printUrl = '';
    // 							}, 1000)
    // 						}
    // 					})
    // 				}
    // 			})
    // 		},500)
    // 	}
    // },
    submit_dialogUser(state) {
      this.dialogUser_state = false;
      if (state === true) {
        this.getUserDetail();
      }
    },
    // tab切换
    changeTab(a) {
      if (this.curTabIndex != a) {
        this.$router.replace({
          path: "/huiyuan/huiyuanSee",
          query: {
            id: this.$route.query.id,
            tab: a,
          },
        });
        setTimeout(() => {
          this.curTabIndex = a;
        }, 50)

        this.page.page = 1;
      }
    },
    // 跳转到tab3
    toTab3(id) {
      this.$router.replace({
        path: "/huiyuan/huiyuanSee",
        query: {
          id: this.$route.query.id,
          tab: 3,
          card_id: id,
        },
      });
      this.curTabIndex = 3;
    },
    getUserDetail() {
      this.page.page = 1;
      this.page.total = 0;
      this.page_recharge.page = 1;
      this.page_recharge.total = 0;
      this.page_discount.page = 1;
      this.page_discount.total = 0;
      let params = {
        id: this.$route.query.id,
      };
      this.$http.get(process.env.VUE_APP_Url_member+"/api/middleware/Member/Single", params).then((res) => {
        if (res.code == 0) {
          res.data.pets_info.map((item, index) => {
            if (item.bron_date) {
              res.data.pets_info[index].petAgeArr = pub.calculatePetAge(item.bron_date)
            }
          })

          this.userDetail = res.data;
          this.getUserOrderList(res.data._id);
          this.getUserOrderRechargeList(res.data._id);
          this.getUserDiscountList(res.data._id);
          this.getUserGiftCardList(res.data._id);
          this.getDeposit(res.data._id);
          this.getRetrunOrderList(res.data._id);
        }
      });
    },

    // 获取用户消费订单
    getUserOrderList(userId) {
      let params = {
        keyword: "",
        userid: userId, // 用户id
        starttime: "",
        endtime: "",
        state: "", // 状态 -1 全部 1 未成功 3 已成功
        pay_type: "", // 支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
        page_index: this.page.page,
        page_size: this.page.pageSize,
      };
      this.$http
        .post(process.env.VUE_APP_Url_order + "/api/CommonOrder/list", params)
        .then((res) => {
          if (res.code == 0) {
            this.orderList = res.data.data;
            this.page.total = res.data.count;
          }
        });
    },
    // 获取用户充值订单
    getUserOrderRechargeList(userId) {
      let params = {
        keyword: "",
        userid: userId, // 用户id
        starttime: "",
        endtime: "",
        state: -1, // 状态 -1 全部 1 未成功 3 已成功
        pay_type: -1, // 支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
        order_source: -1, // -1全部 2 余额 3押金
        page_index: this.page_recharge.page,
        page_size: this.page_recharge.pageSize,
      };
      this.$http
        .post(
          process.env.VUE_APP_Url_order + "/api/OffLineRecharge/list",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            this.orderRechargeList = res.data.data;
            this.page_recharge.total = res.data.count;
          }
        });
    },
    // 获取折扣券列表
    getUserDiscountList(userId) {
      let params = {
        memberId: userId, // 用户id
        pageIndex: this.page_discount.page,
        pageSize: this.page_discount.pageSize,
      };
      let loading = this.$loading();
      this.$http.get("/api/Member/MemberCoupon", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          console.log(res.data.data);
          this.discountList = res.data.data;
          this.page_discount.total = res.data.count;
        }
      });
    },
    // 获取礼品卡
    getUserGiftCardList(userId) {
      let params = {
        memberId: userId,
        page_index: this.page_giftCard.page,
        page_size: this.page_giftCard.pageSize,
      };
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_Url_member + "/api/GiftCard/listByMember",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.giftCardList = res.data;
            this.page_giftCard.total = res.data.length;
          }
        });
    },
    // 获取押金
    getDeposit(memberId) {
      let params = {
        typeId: 0,
        keyword: "",
        startTime: "",
        endTime: "",
        memberId: memberId,
        status: 1, // 是否已结束（0不限；1：进行中；2：已结束）
        hasDeposit: 1, // 是否有押金(0不限；1：有；2：没有)
        pageIndex: 1,
        pageSize: 100,
      };
      this.$http.post("/api/InHospital/List", params).then((res) => {
        if (res.code == 0) {
          this.depositList = res.data.data || [];
        }
      });
    },
    // 获取表格数据
    getRetrunOrderList(userId) {
      let params = {
        keyword: "",
        userid: userId,
        starttime: "",
        endtime: "",
        state: -1, // 状态 -2 已取消 0 已删除 1 已申请 2 已审核 3 退款中 4 物流中 5退款成功
        pay_type: -1, // 支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
        return_type: -1, // 退换货类型  1 退货 2 换货
        source: -1, // 1线上 2线下
        pageSize: 100,
        pageIndex: 1,
      };
      this.$http.post("/api/ReturnOrder/List", params).then((res) => {
        if (res.code == 0) {
          this.returnOrderList = res.data.data;
        }
      });
    },
    handleClick(row) {
      console.log(row);
    },
    deletedPet(id) {
      this.$confirm("此操作将永久删除该宠物, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.get("/api/Pet/Delete", { id }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getUserDetail();
            }
          });
        })
        .catch(() => { });
    },
    // 页码改变
    pageChange(a) {
      this.page.page = a;
      this.getUserOrderList(this.userDetail._id);
    },
    // 页码改变
    page_rechargeChange(a) {
      this.page_recharge.page = a;
      this.getUserOrderRechargeList(this.userDetail._id);
    },
    // 页码改变
    page_discountChange(a) {
      this.page_discount.page = a;
      this.getUserDiscountList(this.userDetail._id);
    },
    // 页码改变
    page_giftCardChange(a) {
      this.page_giftCard.page = a;
      this.getUserGiftCardList(this.userDetail._id);
    },

    // 退款
    refund(a) {
      alert(a);
    },
    // 购买会员卡
    BuyCard() {
      this.dialogBuyCard_state = true;
    },
    dialogCard_submit(data){
      this.dialogBuyCard_state = false;
    },
 
    //、、、、、、、、、、、、、、 宠物  、、、、、、、、、、、、、、、、、、、、、、、、、、、
    openDialogAddEditPet(type, row) {
      this.operationPetType = type;
      this.curPet = row;
      this.dialogAddEditPet_state = true;
    },
    dialogPet_submit(data) {
      this.dialogAddEditPet_state = false;
      if (data !== "close") {
        this.getUserDetail();
      }
    },
    trans(row) {
      this.curPet = row;
      this.dialogTransPet_state = true;
    },
    submit_transPet() {
      this.dialogTransPet_state = false;
      this.getUserDetail();
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .pageTitleBox {}

  .searchLine {
    background-color: #fff;

    .search {
      display: flex;
      justify-content: space-between;
      padding-bottom: 20px;

      .searchL {
        width: 1200px;

        .tit {
          padding-left: 10px;
          border-left: 3px solid #ffd138;
          margin-top: 18px;
          display: inline-block;
        }
      }

      .searchR {
        .nav {
          display: flex;

          .navItem {
            width: 102px;
            line-height: 37px;
            border-radius: 4px;
            text-align: center;
            color: #1a1a1a;
            font-size: 16px;
            margin-left: 30px;
            cursor: pointer;

            &.active {
              background-color: #ffd138;
            }
          }
        }
      }
    }
  }

  .msg {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    border-radius: 4px;

    .msgItem {
      width: 25%;
      font-size: 16px;
      color: $fontColor;
      display: flex;
      line-height: 40px;
      padding: 0 20px;
      border-bottom: 1px solid #f2f2f2;
      font-size: 12px;
      box-sizing: border-box;

      .msgLabel {
        width: 100px;
        text-align: right;
        color: $fontColor;
      }

      .msgValue {}
    }
  }

  .tabLine {
    margin-top: 12px;
    display: flex;

    .tabItem {
      padding: 0 16px;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #f2f2f2;
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;

      &.active {
        color: $mainColor;
      }
    }
  }

  .table {
    min-height: 400px;
  }

  .tableBox {
    border-top: 1px solid #f2f2f2;
  }
}
</style>
